import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';

import { PAGE_ROUTE_PATH } from '@/constants';

/**
 * 内部遷移用カスタムフック
 *
 * @returns
 */
export const useInternalRedirect = () => {
  const navigate = useNavigate();

  /**
   * ログイン画面に内部遷移する
   */
  const internalRedirectToWelcome = useCallback(
    (search?: string) => {
      navigate(
        {
          pathname: PAGE_ROUTE_PATH.WELCOME,
          search: search || '',
        },
        {
          state: { isInternalRedirect: true },
        },
      );
    },
    [navigate],
  );

  return {
    internalRedirectToWelcome,
  };
};
